//#region Imports
/**
To use React related functionality
*/
import React from 'react';
/**
Allows component  to connect the Redux store.
*/
import { connect } from 'react-redux';
/**
It is used to wrap action creators in a dispatch call so that they can be invoked directly from a component.
*/
import { bindActionCreators } from 'redux';
/**
To use Selected current trip 
*/
import { selectCurrentTrip } from '../../actions';
/**
To access all Itinerary of a trip.
*/
import Itinerary from './Itinerary';
// import ShowMore from './ShowMore';
//#endregion

/**
* It is written in Direction>>DirectionList.js
* Used in Direction>>Index
* @return {HTMLElement} list of trips
*/
class DirectionsList extends React.Component {
    constructor(props) {
        super(props);
        //handles click event
        this.handleClick.bind(this);
        //handle state for show more trips and maximum trips
        this.state = {
            showMore: false,
            maxTrips: 3
        };
    }
    //Triggeres when click on Trip
    handleClick(idx) {
        this.props.selectCurrentTrip(idx);
    }
    //Triggeres when click on show more button
    showMore = () => {
        this.setState({showMore: !this.state.showMore});
    }


    render() {        
        //stores loop count and use as an argument for label parameter
        let count = 0;
        //stores array of trip
        let trips = [];
        //stores value for maximum trips
        let tripsMax = this.state.maxTrips;
        //loop over all trips
        this.props.trips.forEach((trip, idx) => {
            /**
            flex2:Flex2 is a feature in OpenTripPlanner (OTP) that allows users to plan trips on flexible transit services. 
            Flexible transit services are those that do not have fixed routes or schedules, such as demand-response shuttles or on-demand ridehailing.
            */
           
            //Check if current configuration is for flex2
            if (window.otpConfig.flex2) {
                //Use Reservation Services is not checked
                if (!this.props.isChecked) {
                    trips.push(trip);
                } else {
                    //check if any of the legs in the trip array require a reservation. 
                    if (!trip.legs.find(leg => leg.requiresReservation)){
                        trips.push(trip);
                    }
                }
            } else {
                trips.push(trip);
            }
        });
        //stores trip length
        let trip_count = trips.length;             
        /**
         The code checks if the number of trips in an array exceeds a certain threshold. 
         If the number of trips exceeds the threshold, the code slices the array to only include the first maxTrips trips.
        */
        if (trips.length > this.state.maxTrips && !this.state.showMore) {
            trips = trips.slice(0, this.state.maxTrips);
        }
      
        // To save updated trip data
        localStorage.setItem('updatedTrips', JSON.stringify(trips));
        return(
            <>
                <div className="otp-accordion">
                    {/* loop over the trips */}
                    {trips.map((trip, idx) => {
                        const tripKey = trip.duration.toString() + trip.startTime.toString() + trip.walkTime.toString() + trip.legs[0].route;
                        count++;
                        return (
                            <Itinerary
                                trip={trip}
                                key={tripKey}
                                label={count}
                                isOpen={idx === this.props.currentTrip}
                                handleClick={() => this.handleClick(idx)}
                            />
                        );
                    })}

                </div>
                {/* if trip count greater than max trips then show show more button */}
                {(trip_count > tripsMax) && 
                <div className="tp-button-primary otp-edit-button">
                    <button onClick = {this.showMore}>{this.state.showMore ? 'Hide Extra Trips' : 'Show More Trips'}</button>
                </div>}
            </>
            
        );
    }
}

const mapDispatch = dispatch => {
    //maps the selectCurrentTrip action to the dispatch function.
    return bindActionCreators({selectCurrentTrip}, dispatch);
};


export default connect(null, mapDispatch)(DirectionsList);